import React from "react";
import SvgIconComponent from "../utils/SvgIconComponent";

function SettingsIcon({color, className, size}) {
  return (
    <SvgIconComponent size={size} color={color}>
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          // fill="#9B9B9F"
          d="M23.681 6.943c-.374-.867-1.406-1.525-2.296-1.462-.89.062-1.92-.286-2.375-.72-.456-.435-.826-1.462-.792-2.357.033-.896-.655-1.899-1.536-2.25-.88-.35-2.07-.083-2.656.586-.586.67-1.567 1.162-2.19 1.181-.625.02-1.618-.449-2.223-1.102C9.01.167 7.806-.066 6.94.31c-.866.374-1.528 1.406-1.466 2.296.062.89-.285 1.92-.72 2.376-.434.456-1.46.821-2.351.793-.89-.03-1.898.657-2.248 1.538-.35.881-.084 2.072.585 2.657.67.586 1.161 1.568 1.18 2.19.02.621-.446 1.617-1.1 2.222-.656.605-.891 1.805-.512 2.676.38.872 1.406 1.53 2.296 1.467.89-.062 1.92.286 2.376.72.456.434.825 1.457.792 2.352-.034.896.655 1.899 1.538 2.25.883.35 2.07.083 2.656-.586.585-.67 1.564-1.162 2.188-1.172.624-.009 1.617.454 2.227 1.107.61.653 1.81.876 2.675.502.867-.375 1.529-1.402 1.467-2.293-.063-.89.285-1.92.72-2.376.434-.456 1.458-.821 2.353-.785.895.036 1.898-.655 2.248-1.538.35-.884.09-2.072-.585-2.662-.674-.59-1.166-1.56-1.183-2.192-.017-.631.449-1.618 1.106-2.222a2.566 2.566 0 00.5-2.686zm-9.838 9.346a4.667 4.667 0 01-6.14-2.436 4.673 4.673 0 012.438-6.14 4.667 4.667 0 016.138 2.44 4.672 4.672 0 01-2.428 6.136h-.008z"
        ></path>
      </svg>
    </SvgIconComponent>
  );
}

export default SettingsIcon;